import { css } from "styled-components"
import { blueEllipseGradient, colors } from "../../../../helpers/colors"
import { fonts } from "../../../../helpers/fonts"

export const MenuItemWrapperStyles = css`
  font-size: ${fonts.sizes[2]};
`
export const MenuLinkStyles = css`
  &:hover {
    ${blueEllipseGradient}
  }
`
export const SubmenuItemStyles = css`
  &:hover {
    background: ${colors.blueGradientStart};
  }
`
export const SubmenuWrapperStyles = css`
  background: ${colors.blueGradientEnd};
`
